// extracted by mini-css-extract-plugin
module.exports = {"root":"CountView_root__2UftS","item":"CountView_item__3bCqf","text":"CountView_text__uH07D","count":"CountView_count__XrdZr"};